import { MyLensesRoleType, Visibility } from "../../gql-generated/types";

export enum ROLE_ACTIONS {
    LENS_FOLDER_LENS_DELETE,
    UPDATE_LENS_VISIBILITY,
    PUBLISH_LENS,
    READ_LENS_INSIGHTS,
    VIEW_CREATOR_REWARDS,
}

export interface LensFolderRoleTypePermissions {
    VISIBILITY_OPTIONS: Visibility[];
    ACTIONS: ROLE_ACTIONS[];
}

export type LensFolderRoleType =
    | MyLensesRoleType.RoleTypeUnset
    | MyLensesRoleType.RoleTypeLensFolderAdmin
    | MyLensesRoleType.RoleTypeLensFolderManager
    | MyLensesRoleType.RoleTypeLensFolderCreator;

export type OrganizationRoleType =
    | MyLensesRoleType.RoleTypeUnset
    | MyLensesRoleType.RoleTypeMember
    | MyLensesRoleType.RoleTypeAdmin;

type LensFolderRoleTypePermissionsMap = Record<LensFolderRoleType, LensFolderRoleTypePermissions>;

export const LENS_FOLDER_ROLE_TYPE_PERMISSIONS: LensFolderRoleTypePermissionsMap = {
    [MyLensesRoleType.RoleTypeUnset]: {
        VISIBILITY_OPTIONS: [],
        ACTIONS: [],
    },
    [MyLensesRoleType.RoleTypeLensFolderAdmin]: {
        VISIBILITY_OPTIONS: [
            Visibility.VisibilityDontPublishToSnapchat,
            Visibility.VisibilityHidden,
            Visibility.VisibilityOffline,
            Visibility.VisibilityPublic,
        ],
        ACTIONS: [
            ROLE_ACTIONS.LENS_FOLDER_LENS_DELETE,
            ROLE_ACTIONS.UPDATE_LENS_VISIBILITY,
            ROLE_ACTIONS.READ_LENS_INSIGHTS,
            ROLE_ACTIONS.PUBLISH_LENS,
            ROLE_ACTIONS.VIEW_CREATOR_REWARDS,
        ],
    },
    [MyLensesRoleType.RoleTypeLensFolderManager]: {
        VISIBILITY_OPTIONS: [
            Visibility.VisibilityDontPublishToSnapchat,
            Visibility.VisibilityHidden,
            Visibility.VisibilityOffline,
            Visibility.VisibilityPublic,
        ],
        ACTIONS: [
            ROLE_ACTIONS.LENS_FOLDER_LENS_DELETE,
            ROLE_ACTIONS.UPDATE_LENS_VISIBILITY,
            ROLE_ACTIONS.READ_LENS_INSIGHTS,
            ROLE_ACTIONS.PUBLISH_LENS,
            ROLE_ACTIONS.VIEW_CREATOR_REWARDS,
        ],
    },
    [MyLensesRoleType.RoleTypeLensFolderCreator]: {
        VISIBILITY_OPTIONS: [Visibility.VisibilityDontPublishToSnapchat],
        ACTIONS: [],
    },
};

type OrganizationRoleTypePermissionsMap = Record<OrganizationRoleType, LensFolderRoleTypePermissions>;

export const ORGANIZATION_ROLE_TYPE_PERMISSIONS: OrganizationRoleTypePermissionsMap = {
    [MyLensesRoleType.RoleTypeUnset]: {
        ...LENS_FOLDER_ROLE_TYPE_PERMISSIONS[MyLensesRoleType.RoleTypeUnset],
    },
    [MyLensesRoleType.RoleTypeMember]: {
        ...LENS_FOLDER_ROLE_TYPE_PERMISSIONS[MyLensesRoleType.RoleTypeUnset],
    },
    [MyLensesRoleType.RoleTypeAdmin]: {
        ...LENS_FOLDER_ROLE_TYPE_PERMISSIONS[MyLensesRoleType.RoleTypeLensFolderAdmin],
    },
};
